import React from 'react';

import CatalogShell from './CatalogShell';

const WalletTypes: React.FC = () => (
  <CatalogShell
    slug="wallet-types"
    title="Wallet types"
    breadcrumbLabel="Wallet types"
    emptyBody="Wallet types classify consumer wallets (reward, funding, master). FK parent for config.wallet.wallet_type_code."
    addCtaLabel="Add first wallet type"
  />
);

export default WalletTypes;
